/**
 * Vachtvreugde: focusherstel in de cart drawer (fase 2E).
 *
 * Horizon verwijdert bij "verwijderen" de hele winkelwagenregel, inclusief de knop die de focus had.
 * De focus valt dan terug op <body>, achter de drawer. Na een winkelwagen-update zetten we de focus
 * terug in de open drawer (kop, of de knop van de lege winkelwagen). Er wordt niets gedaan als de focus
 * nog binnen de drawer staat of de drawer dicht is.
 */
(() => {
  const CART_EVENT = 'shopify:cart:lines-update';
  const CHECK_DELAYS = [150, 400, 800];

  /** @returns {HTMLDialogElement | null} */
  const openDrawer = () => document.querySelector('#cart-drawer dialog[open]');

  const restoreFocus = () => {
    const dialog = openDrawer();
    if (!dialog) return;

    const active = document.activeElement;
    if (active && active !== document.body && dialog.contains(active)) return;

    const target =
      dialog.querySelector('.cart-items__empty-button') ||
      dialog.querySelector('#cart-drawer-heading') ||
      dialog.querySelector('.theme-drawer__close-button');
    if (!(target instanceof HTMLElement)) return;

    if (!target.matches('a[href], button, [tabindex]')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  };

  document.addEventListener(CART_EVENT, () => {
    CHECK_DELAYS.forEach((delay) => setTimeout(restoreFocus, delay));
  });
})();
